/* eslint-disable */
import { Fancybox } from '@fancyapps/ui/dist/fancybox/';

export default function fancyappsModal() {
  Fancybox.bind("[data-fancybox]", {
    dragToClose: false,
    Carousel: {
      Thumbs: false,
      Toolbar: {
        display: {
          right: ['close'],
        }
      },
      Panzoom: 'base',
    },
  });
}
